





import React, { useState } from 'react';
import Layout from '../components/Layout/Layout';

const Policy = () => {
  const [showFullContent, setShowFullContent] = useState(false);

  const toggleReadMore = () => {
    setShowFullContent(!showFullContent);
  };

  return (
    <Layout title={"Privacy Policy"}>
      <div className="row contactus">
        <div className="col-md-6">
          <img
            src="/images/privacyPolicy.jpg"
            alt="contactus"
            style={{ width: "100%" }}
          />
        </div>
        <div className="col-md-4">
          <h2 className='text-center'>Privacy Policy</h2>
          {showFullContent ? (
            <>
              <p>
                3sixsteen Shopping is committed to protecting your privacy. This Privacy Policy outlines how your personal information is collected, used, and shared when you visit or make a purchase from our website.
              </p>
              <h4 className='text-center'>Information We Collect</h4>
        <p>When you visit the site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device. Additionally, as you browse the site, we collect information about the individual web pages or products that you view, what websites or search terms referred you to the site, and information about how you interact with the site.

            W</p>
              <h5 className='text-center'>How We Use Your Information</h5>
              <p>
                We use the Order Information that we collect generally to fulfill any orders placed through the site (including processing your payment information, arranging for shipping, and providing you with invoices and/or order confirmations).
                Additionally, we use this Order Information to:
                Communicate with you;
               
              </p>
            </>
          ) : (
            <p>
              3sixsteen Shopping is committed to protecting your privacy. This Privacy Policy outlines how your personal information is collected, used, and shared when you visit or make a purchase from our website.
            </p>
          )}
          <button onClick={toggleReadMore} className='btn btn-link'>
            {showFullContent ? 'Read Less' : 'Read More'}
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default Policy;

